import React from 'react';
import { Avatar, AvatarSize } from 'wix-ui-tpa/cssVars';
import { useTranslate } from '../../../../context/api-context/translations/use-translate';
import { useRemainingWidth } from '../use-remaining-width/use-remaining-width';
import { classes } from './comment-box-outer-footer.st.css';
export const CommentBoxOuterFooter = ({ publishControls, currentMember, }) => {
    const { maxWidth, containerRef, elementRef } = useRemainingWidth();
    const t = useTranslate();
    return (React.createElement("div", { className: classes.root, ref: containerRef },
        React.createElement("div", { className: classes.commentingAs, ref: elementRef }, currentMember?.profile && [
            React.createElement(Avatar, { className: classes.avatar, size: AvatarSize.xSmall, src: currentMember.profile.photo?.url }),
            React.createElement("div", { className: classes.name }, t('comment-box-footer.commenting-as', {
                name: currentMember.profile.nickname,
            })),
        ]),
        React.createElement("div", { className: classes.publishControls, style: { maxWidth: maxWidth ?? 'auto' } }, publishControls)));
};
//# sourceMappingURL=comment-box-outer-footer.js.map